import { Reveal } from "./Reveal";

const REGIONS = ["Podkarpackie", "Małopolskie", "Lubelskie", "Świętokrzyskie"];
const CITIES = ["Rzeszów", "Kraków", "Lublin", "Kielce", "Tarnów", "Krosno", "Przemyśl", "Mielec"];

export const Region = () => (
  <section id="region" data-testid="region-section" className="py-24 lg:py-36">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
      <div className="grid grid-cols-1 gap-14 lg:grid-cols-12 lg:gap-20">
        <Reveal className="lg:col-span-5">
          <p className="mb-4 font-mono text-xs font-semibold uppercase tracking-[0.2em] text-[#8C6D46]">
            Obszar działania
          </p>
          <h2 className="font-serif text-2xl font-semibold leading-tight tracking-tight text-slate-950 sm:text-3xl lg:text-4xl">
            Polska południowo-wschodnia
          </h2>
          <p className="mt-6 text-base leading-relaxed text-slate-600">
            Szczególnie dobrze znam rynek Polski południowo-wschodniej. W przypadku większych
            projektów współpraca może obejmować również pozostałą część Polski.
          </p>
          <div data-testid="region-voivodeships" className="mt-8 flex flex-wrap gap-3">
            {REGIONS.map((r) => (
              <span
                key={r}
                className="rounded-full border border-slate-300 px-5 py-2 text-sm font-medium text-slate-700 transition-colors duration-300 hover:border-[#8C6D46] hover:text-[#8C6D46]"
              >
                {r}
              </span>
            ))}
          </div>
          <p className="mt-8 font-mono text-[11px] uppercase tracking-[0.18em] text-slate-400">
            {CITIES.join("  •  ")}
          </p>
        </Reveal>

        <Reveal className="lg:col-span-7" delay={0.15}>
          <div className="overflow-hidden rounded-sm border border-slate-200">
            <iframe
              title="Mapa — Polska południowo-wschodnia"
              data-testid="region-map-embed"
              src="https://www.google.com/maps?q=Rzesz%C3%B3w,%20Polska&z=7&output=embed"
              className="h-[380px] w-full grayscale contrast-[1.05] lg:h-[460px]"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
